import * as React from 'react';
import { Ref, Segment, Table as UITable } from 'semantic-ui-react';
import { InfoCardDetailType } from '~/Api/InfoCard';
import { StatisticsTableDescription } from '~/InfoCard/Details/StatisticsTableDescription';
export var OrderPackages = function (_a) {
    var detail = _a.detail, headers = _a.headers, yearCounter = _a.yearCounter, children = _a.children;
    var ref1 = React.useRef(null);
    var ref2 = React.useRef(null);
    var ref3 = React.useRef(null);
    var _b = React.useState([0, 0, 0]), margin = _b[0], setMargin = _b[1];
    React.useEffect(function () {
        if (ref1.current !== null && ref2.current !== null && ref3.current !== null) {
            setMargin([
                ref1.current.offsetWidth,
                ref2.current.offsetWidth + ref1.current.offsetWidth,
                ref3.current.offsetWidth + ref1.current.offsetWidth + ref2.current.offsetWidth,
            ]);
        }
    }, []);
    return (<div data-testid={detail.type}>
			{children}
			<Segment.Group compact>
				<UITable celled striped structured unstackable className='sticky-column-4' size='small'>
					<UITable.Header>
						<UITable.Row>
							<UITable.HeaderCell colSpan={4} style={{ left: 0 }}/>
							{Object.entries(yearCounter).map(function (_a) {
            var key = _a[0], value = _a[1];
            return (<UITable.HeaderCell colSpan={value} key={key} textAlign='center'>
									{key}
								</UITable.HeaderCell>);
        })}
						</UITable.Row>
						<UITable.Row>
							<Ref innerRef={ref1}>
								<UITable.HeaderCell data-testid='record-header' style={{ left: 0 }}>
									{detail.type === InfoCardDetailType.providersPackagesInOrdersStatistics
            ? 'Poskytovatel'
            : 'Název protistrany'}
								</UITable.HeaderCell>
							</Ref>
							<Ref innerRef={ref2}>
								<UITable.HeaderCell data-testid='record-header' style={{ left: margin[0] }}>
									Lečivý přípravek
								</UITable.HeaderCell>
							</Ref>
							<Ref innerRef={ref3}>
								<UITable.HeaderCell data-testid='record-header' style={{ left: margin[1] }}>
									Doplněk
								</UITable.HeaderCell>
							</Ref>
							<UITable.HeaderCell data-testid='record-header' style={{ left: margin[2] }}>
								SUKL kód
							</UITable.HeaderCell>
							{headers.map(function (header) { return (<UITable.HeaderCell data-testid='record-header' key={header} textAlign='center'>
									{new Intl.DateTimeFormat('cs-CZ', { month: 'long' }).format(new Date(header))}
								</UITable.HeaderCell>); })}
						</UITable.Row>
					</UITable.Header>
					<UITable.Body>
						{detail.statistics.map(function (statistics) {
            return statistics.packagesStatistics.map(function (packages, k) {
                var _a;
                return (<UITable.Row data-testid='record' key={k}>
									<UITable.Cell singleLine style={{ left: 0 }}>
										{k === 0 ? (_a = statistics.supplier) !== null && _a !== void 0 ? _a : statistics.provider : null}
									</UITable.Cell>
									<UITable.Cell singleLine style={{ left: margin[0] }}>
										{packages.brand}
									</UITable.Cell>
									<UITable.Cell singleLine style={{ left: margin[1] }}>
										{packages.supplement}
									</UITable.Cell>
									<UITable.Cell singleLine style={{ left: margin[2] }}>
										{packages.suklCode}
									</UITable.Cell>
									{headers.map(function (header) {
                        var _a;
                        return (<UITable.Cell singleLine key={header} textAlign='right'>
											{(_a = statistics.packagesStatistics[k].records[header]) !== null && _a !== void 0 ? _a : 'No data'}
										</UITable.Cell>);
                    })}
								</UITable.Row>);
            });
        })}
					</UITable.Body>
				</UITable>
			</Segment.Group>
			<StatisticsTableDescription />
		</div>);
};
